import { buildShells } from "../arena/shells";
import type { UpgradeEffects } from "../upgrades/effects";
import type { UpgradeKind } from "../upgrades/definitions";
import type { ShellState } from "./types";

export function rebuildShellsKeepingAngles(shells: readonly ShellState[], effects: UpgradeEffects): readonly ShellState[] {
  const previousAngles = new Map(shells.map((shell) => [shell.index, shell.angleDegrees]));
  return buildShells(effects).map((shell) => ({
    ...shell,
    angleDegrees: previousAngles.get(shell.index) ?? shell.angleDegrees
  }));
}

export function upgradeFeedbackTargets(kind: UpgradeKind): readonly string[] {
  if (kind === "MaxCores") {
    return ["active-cores"];
  }

  if (kind === "CoreValue" || kind === "ChargeBonus" || kind === "CollectorAmp" || kind === "CriticalDischarge") {
    return ["credits"];
  }

  if (kind === "GateWidth" || kind === "GateCount" || kind === "ExtraShell" || kind === "ShellSpeed" || kind === "ShellLens") {
    return ["arena"];
  }

  if (kind === "OverchargedCore" || kind === "PolaritySync") {
    return ["arena", "credits"];
  }

  return [];
}
